
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppFileUpload, AppButton, AppSelect } from '@/components';
import { useItemAdd } from '@/modules/item/system/model/add';
import { RewardFeatures } from '@/common/reward/types';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';

export default defineComponent({
    name: ROUTE_NAME_ITEM.SYSTEM.ADD,
    components: { AppFormRow, AppInput, AppCard, AppFileUpload, AppButton, AppSelect },
    setup() {
        const { model, v$, actions } = useItemAdd();

        return { v$, model, actions, RewardFeatures };
    }
});
